import { Card, Flex } from "antd";
import NoteCopyButton from "../../components/CopyButton/CopyButton.component";
import { useAppSelector } from "../../hooks/redux-hooks";
import type { NoteSection } from "../../utils/analytics";
import { copySectionContent } from "../../utils/datamanipulation.utils";
import NoteSectionTitle from "./NoteSectionTitle.component";
import NotesTextArea from "./NotesTextArea.component";
import SaveButton from "./SaveButton.component";
import styles from "./notes.module.scss";

const NoteSectionEdit = ({
  value,
  title,
  field,
  analyticsField,
  bigger = false,
  handleSaveClick,
  hideHeader = true,
}: {
  value: string;
  title: string;
  field: string;
  bigger?: boolean;
  analyticsField: NoteSection;
  handleSaveClick: () => void;
  hideHeader?: boolean;
}) => {
  const componentName = "notes";
  const { notesDetails } = useAppSelector((state) => state.notes);
  const onCopy = () => {
    if (!notesDetails) return;
    copySectionContent(notesDetails, value, analyticsField);
  };
  return (
    <Flex className={`${styles[`${componentName}__main-container`]}`}>
      {!hideHeader ? (
        <Card className={`${styles[`${componentName}__main-section`]}`} hoverable>
          {!hideHeader && (
            <Flex
              className={`${styles[`${componentName}__main-section-header-section`]}`}
              justify="space-between"
              align="center"
            >
              <NoteSectionTitle title={title} />
              <NoteCopyButton onClick={onCopy} />
            </Flex>
          )}
          <NotesTextArea
            style={hideHeader ? {} : { marginTop: "18px", paddingTop: "10px", borderTop: "1px solid #e0e0e0" }}
            value={value}
            field={field}
            bigger={bigger}
          />
          <SaveButton onClick={handleSaveClick} />
        </Card>
      ) : (
        <Flex
          vertical
          style={{
            width: "100%",
          }}
        >
          <NotesTextArea
            style={hideHeader ? {} : { marginTop: "0px", paddingTop: "10px", borderTop: "1px solid #e0e0e0" }}
            value={value}
            field={field}
            bigger={bigger}
          />
          <SaveButton onClick={handleSaveClick} />
        </Flex>
      )}
    </Flex>
  );
};

export default NoteSectionEdit;
